import { CircularProgress } from "@mui/material";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { PinnacleTextField } from "../PinnacleTextField";

export const PinnacleSearchField = ({ id, label, value, onChange, isLoading, disabled }: {
    id: string;
    label: string;
    value: string;
    onChange: (val: string) => void;
    isLoading: boolean;
    disabled?: boolean;
}) => (
    <PinnacleTextField
        id={id}
        label={label}
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{ 'aria-label': 'search-terms' }}
        disabled={disabled}
        sx={{
            width: '400px',
            '& .MuiInputBase-root': {
                height: '40px',
                boxSizing: 'border-box',
            },
            '& .MuiInputLabel-root': {
                top: '-6px',
            },
        }}
        slotProps={{
            input: {
                endAdornment: isLoading
                    ? <CircularProgress size={18} sx={{ color: 'action.active', mr: 1 }} />
                    : <SearchOutlinedIcon sx={{ color: 'action.active' }} />,
            },
        }}
    />
);
